import React from 'react';
import { useNotification } from '../contexts/NotificationContext';
import { X, CheckCircle, AlertCircle, Info } from 'lucide-react';

const NotificationContainer = () => {
  const { notifications, removeNotification } = useNotification();

  const getIcon = type => {
    switch (type) {
      case 'success':
        return <CheckCircle size={20} className="text-green-400" />;
      case 'error':
        return <AlertCircle size={20} className="text-red-400" />;
      case 'info':
        return <Info size={20} className="text-red-400" />;
      default:
        return <CheckCircle size={20} className="text-green-400" />;
    }
  };

  const getStyles = type => {
    switch (type) {
      case 'success':
        return 'bg-black border-green-600 text-green-400';
      case 'error':
        return 'bg-black border-red-600 text-red-400';
      case 'info':
        return 'bg-black border-red-600 text-red-400';
      default:
        return 'bg-black border-green-600 text-green-400';
    }
  };

  if (notifications.length === 0) return null;

  return (
    <div className="fixed top-4 right-4 z-50 space-y-2">
      {notifications.map(notification => (
        <div
          key={notification.id}
          className={`
            flex items-center gap-3 px-4 py-3 rounded-lg border shadow-lg max-w-sm
            ${getStyles(notification.type)}
            animate-in slide-in-from-right duration-300
            cursor-pointer hover:shadow-xl transition-all
          `}
          onClick={() => removeNotification(notification.id)}
        >
          {getIcon(notification.type)}
          <span className="flex-1 text-sm font-medium">{notification.message}</span>
          <button
            onClick={e => {
              e.stopPropagation();
              removeNotification(notification.id);
            }}
            className="text-current opacity-60 hover:opacity-100 transition-opacity"
            aria-label="Close notification"
          >
            <X size={16} />
          </button>
        </div>
      ))}
    </div>
  );
};

export default NotificationContainer;
